/** @jsx jsx */
import { jsx, IconButton } from 'theme-ui'
import React, { useState } from 'react'
import Gold from '../../../icons/gold.svg'
import Silver from '../../../icons/silver.svg'
import RG from '../../../icons/roseGold.svg'
import SilverGold from '../../../icons/silverGold.svg'
import GoldSilver from '../../../icons/goldSilver.svg'
import Diamond from '../../../icons/diamond.svg'
import Black from '../../../icons/blackSwatch.svg'
import BlackDiamond from '../../../icons/blackDiamond.svg'

const RoseSwatch = ({ border, ...rest }) => {
  return (
    <img
      width="28px"
      height="28px"
      sx={{
        pointerEvents: ['none', 'none', 'auto'],
        borderRadius: '100%',
        padding: '2px',
        border: border && '2px solid #76746F',
      }}
      src={RG}
      alt="RG"
    />
  )
}

const BlackSwatch = ({ border, ...rest }) => {
  return (
    <img
      width="28px"
      height="28px"
      sx={{
        pointerEvents: ['none', 'none', 'auto'],
        borderRadius: '100%',
        padding: '2px',
        border: border && '2px solid #76746F',
      }}
      src={Black}
      alt="Black"
    />
  )
}

const DiamondSwatch = ({ border, ...rest }) => {
  return (
    <img
      width="28px"
      height="28px"
      sx={{
        pointerEvents: ['none', 'none', 'auto'],
        borderRadius: '100%',
        padding: '2px',
        border: border && '2px solid #76746F',
      }}
      src={Diamond}
      alt="Diamond"
    />
  )
}
const BlackDiamondSwatch = ({ border, ...rest }) => {
  return (
    <img
      width="28px"
      height="28px"
      sx={{
        pointerEvents: ['none', 'none', 'auto'],
        borderRadius: '100%',
        padding: '2px',
        border: border && '2px solid #76746F',
      }}
      src={BlackDiamond}
      alt="BlackDiamond"
    />
  )
}

const SilverSwatch = ({ border, color }) => {
  return (
    <img
      width="28px"
      height="28px"
      sx={{
        pointerEvents: ['none', 'none', 'auto'],
        borderRadius: '100%',
        padding: '2px',
        border: border && '2px solid #76746F',
      }}
      src={Silver}
      alt="Silver"
    />
  )
}

const GoldSwatch = ({ border }) => {
  return (
    <img
      width="28px"
      height="28px"
      sx={{
        pointerEvents: ['none', 'none', 'auto'],
        borderRadius: '100%',
        padding: '2px',
        border: border && '2px solid #76746F',
      }}
      src={Gold}
      alt="Gold"
    />
  )
}

const GoldSilverSwatch = ({ border }) => {
  return (
    <img
      width="28px"
      height="28px"
      sx={{
        pointerEvents: ['none', 'none', 'auto'],
        borderRadius: '100%',
        padding: '2px',
        border: border && '2px solid #76746F',
      }}
      src={GoldSilver}
      alt="GoldSilver"
    />
  )
}

const SilverGoldSwatch = ({ border }) => {
  return (
    <img
      width="28px"
      height="28px"
      sx={{
        pointerEvents: ['none', 'none', 'auto'],
        borderRadius: '100%',
        padding: '2px',
        border: border && '2px solid #76746F',
      }}
      src={SilverGold}
      alt="SilverGold"
    />
  )
}

function checkType(color, border) {
  if (color === 'black-diamond') {
    return <BlackDiamondSwatch border={border} />
  }
  if (color.includes('diamond')) {
    return <DiamondSwatch border={border} />
  }
  if (color === 'black') {
    return <BlackSwatch border={border} />
  }
  if (color === 'rose-gold') {
    return <RoseSwatch border={border} />
  }
  if (color === 'silver' || color === 'white-gold') {
    return <SilverSwatch border={border} />
  }
  if (color === 'gold-silver') {
    return <GoldSilverSwatch border={border} />
  }
  if (color === 'silver-gold') {
    return <SilverGoldSwatch border={border} />
  }

  return <GoldSwatch border={border} />
}

const StyledButton = ({ color, ...props }) => {
  return (
    <IconButton {...props} onClick={() => props.onClick(color)}>
      {checkType(color, props.isActive)}
    </IconButton>
  )
}

export default StyledButton
